module.exports = __webpack_public_path__ + "static/media/lv2-1c.1997b1c6.mp3";